import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ActionKind } from "../../types/Action";
import { Button } from "../Button";
import { Dialog } from "../Dialog";
import { useAnyState } from "../state/StateProvider";

export const ChangeLanguageDialog = () => {
    const { t, i18n } = useTranslation();
    const [isLanguagePickerOpen, setIsLanguagePickerOpen] = useState(false);
    const { dispatch } = useAnyState();

    const languages = (i18n.options.supportedLngs as string[]).filter(
        (l) => l !== "cimode"
    );
    const current = i18n.language.toUpperCase();

    return (
        <>
            {isLanguagePickerOpen && (
                <Dialog
                    title={t("changeLanguage")}
                    onBackgroundClick={() => setIsLanguagePickerOpen(false)}
                >
                    <div className="flex justify-center gap-4">
                        {languages.map((code) => (
                            <Button
                                variant={
                                    code === i18n.language
                                        ? "primary"
                                        : "default"
                                }
                                onClick={() => {
                                    dispatch({
                                        kind: ActionKind.ChangeLanguage,
                                        code
                                    });
                                    setIsLanguagePickerOpen(false);
                                }}
                                key={code}
                            >
                                {code.toUpperCase()}
                            </Button>
                        ))}
                    </div>
                </Dialog>
            )}
            <Button
                variant="secondary"
                className="z-10 text-xs"
                onClick={() => setIsLanguagePickerOpen(true)}
            >
                {current}
            </Button>
        </>
    );
};
